import initialState from './state.js'
export default {
  RESET_CLIENTES_MODULE(state) {
    Object.keys(initialState).forEach((key) => {
      state[key] = initialState[key]
    })
  },
}
